import { useEffect, useRef, useState } from 'react';

function LazyOnView({ children, rootMargin = '100px', threshold = 0.7, delay = 100 }) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay);
          observer.disconnect();
        }
      },
      { rootMargin, threshold }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [delay, rootMargin, threshold]);

  return (
    <div
      ref={ref}
      className={`transition-opacity duration-200 ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}
    >
      <div style={{ opacity: isVisible ? 1 : 0, transition: 'opacity 300ms ease-in-out' }}>
        {children}
      </div>
    </div>
  );
}

export default LazyOnView;